import {
	PRODUCT_TYPE_ALL,
	getDeviceProductType
} from '../../dashboard/product-filter';

export const filterDevicesByProduct = (devices, productType) => {
	const parsedProductType = parseInt(productType);
	const deviceList = devices || [];

	if (parsedProductType === PRODUCT_TYPE_ALL || Number.isNaN(parsedProductType)) {
		return deviceList;
	}

	return deviceList.filter(device => getDeviceProductType(device) === parsedProductType);
};

export const updateDeviceIcons = (deviceIcons, iconIndexBySerial, serialNumbers, currentIcon) => {
	let nextDeviceIcons = deviceIcons;
	let changed = false;

	serialNumbers.forEach(serialNumber => {
		const iconIndex = iconIndexBySerial.get(String(serialNumber));
		if (iconIndex === undefined) return;

		const deviceIcon = nextDeviceIcons[iconIndex];
		if (!deviceIcon || deviceIcon.current_icon === currentIcon) return;

		if (!changed) {
			nextDeviceIcons = deviceIcons.slice();
			changed = true;
		}

		nextDeviceIcons[iconIndex] = Object.assign({}, deviceIcon, { current_icon: currentIcon });
	});

	return nextDeviceIcons;
};
